// Détection et résolution du mode UI

import {UIMode} from '../types/flipcardTypes';

export const handleUIMode = (editor: any): 'native' | 'embedded' | 'external' => {
  const configuredMode: UIMode = editor.getParam('flipcard_ui_mode', 'native');

  if (configuredMode === 'native') {
    return 'native';
  }

  if (configuredMode === 'embedded') {
    return 'embedded';
  }

  if (configuredMode === 'external') {
    return 'external';
  }

  return 'native';
}
